export default __webpack_public_path__ + "static/media/tubing-group-icon-green.eb174ee2.svg";